import { apiV2 } from 'lib/api/v2'
import useSwr from 'swr'

import { type CorporateConfig } from './types'

async function fetcher() {
  const { data } = await apiV2.get<CorporateConfig>(`private/corporate/config`)

  return data
}

export function useCorporateConfig() {
  return useSwr('getCorporateConfig', fetcher)
}
